import { SVGProps } from 'react';

const EditIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_643_5985)">
      <path
        d="M22.1063 1.01724C21.0797 -0.00932619 19.4203 -0.00932619 18.3937 1.01724L16.9828 2.42349L21.5719 7.01255L22.9828 5.60161C24.0094 4.57505 24.0094 2.91567 22.9828 1.88911L22.1063 1.01724ZM8.08125 11.3297C7.79531 11.6157 7.575 11.9672 7.44844 12.3563L6.06094 16.5188C5.925 16.9219 6.03281 17.3672 6.33281 17.6719C6.63281 17.9766 7.07812 18.0797 7.48594 17.9438L11.6484 16.5563C12.0328 16.4297 12.3844 16.2094 12.675 15.9235L20.5172 8.07661L15.9234 3.48286L8.08125 11.3297ZM4.5 3.00005C2.01562 3.00005 0 5.01567 0 7.50005V19.5C0 21.9844 2.01562 24 4.5 24H16.5C18.9844 24 21 21.9844 21 19.5V15C21 14.1704 20.3297 13.5 19.5 13.5C18.6703 13.5 18 14.1704 18 15V19.5C18 20.3297 17.3297 21 16.5 21H4.5C3.67031 21 3 20.3297 3 19.5V7.50005C3 6.67036 3.67031 6.00005 4.5 6.00005H9C9.82969 6.00005 10.5 5.32974 10.5 4.50005C10.5 3.67036 9.82969 3.00005 9 3.00005H4.5Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_643_5985">
        <path d="M0 0H24V24H0V0Z" fill="none" />
      </clipPath>
    </defs>
  </svg>
);

export default EditIcon;
